import React from "react";
import "./ChipsLabel.scss";
import { AspectRatio, isDevReact, nFormatter } from "../api/ReplayVariables";
import NumberFormat from "react-number-format";
import PlayerWindowPositions from "../api/PlayerWindowPositions";

function ChipsLabel({
  seats,
  seat,
  imgPosition,
  zonePosition,
  realTableRatio,
  bigBlind,
  bbMode,
  player,
  onMove
}) {
  const top =
    imgPosition.top -
    zonePosition.top +
    PlayerWindowPositions[seats + "_" + seat + "_chipsTop"] * realTableRatio +
    "px";
  const left =
    imgPosition.left -
    zonePosition.left +
    PlayerWindowPositions[seats + "_" + seat + "_chipsLeft"] * realTableRatio +
    "px";

  let startPosition = { x: 0, y: 0 };
  let dragging = false;

  const onDragStart = (evt) => {
    startPosition = { x: evt.screenX, y: evt.screenY };
    //console.log("onDragStart", startPosition);
  };
  const onDrag = (evt) => {
    dragging = true;
    //console.log("drag", evt);
  };
  const onDragEnd = (evt) => {
    if (dragging) {
      console.log("repositionedSeat", seat);

      let newPosition = { x: evt.screenX, y: evt.screenY };
      //console.log("onDragEnd", newPosition);
      let diff = {
        x: Math.floor((newPosition.x - startPosition.x) / realTableRatio),
        y: Math.floor((newPosition.y - startPosition.y) / realTableRatio)
      };
      //console.log("diff", diff);
      console.log(
        "before PlayerWindowPositions[" +
          seats +
          "_" +
          seat +
          "_chipsTop" +
          "]:" +
          PlayerWindowPositions[seats + "_" + seat + "_chipsTop"]
      );
      let newTop =
        PlayerWindowPositions[seats + "_" + seat + "_chipsTop"] + diff.y;
      let newLeft =
        PlayerWindowPositions[seats + "_" + seat + "_chipsLeft"] + diff.x;
      PlayerWindowPositions[seats + "_" + seat + "_chipsTop"] = newTop;
      PlayerWindowPositions[seats + "_" + seat + "_chipsLeft"] = newLeft;
      dragging = false;
      console.log(
        "after PlayerWindowPositions[" +
          seats +
          "_" +
          seat +
          "_chipsTop" +
          "]:" +
          PlayerWindowPositions[seats + "_" + seat + "_chipsTop"]
      );
      //console.log("diff", diff);
      //console.log(PlayerWindowPositions);
      onMove();
    }
  };

  const labelWidth = AspectRatio.refChipsLabelWidth * realTableRatio + "px";
  const textWidth = AspectRatio.refChipsLabelTextWidth * realTableRatio + "px";
  //console.log("width", textWidth);
  return (
    <div
      draggable={isDevReact()}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDrag={onDrag}
      className="chips-label"
      style={{
        top: top,
        left: left,
        textAlign: "center",
        display: player.chipsOnTable > 0 ? "inline" : "none",
        width: labelWidth,
        //display: player.chips > 0 ? "inline" : "none",
        fontSize:
          Math.round(AspectRatio.refFontSize * realTableRatio * 1.15) + "px"
      }}
    >
      <div
        className="value"
        style={{
          width: textWidth,
          float: "center",
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        &nbsp;
        {bbMode ? (
          <NumberFormat
            value={+(Math.round(player.chipsOnTable + "e+2")) / +(Math.round(bigBlind + "e+2"))}
            displayType={"text"}
            thousandSeparator={true}
            decimalScale="1"
            renderText={(value) => <>{value}</>}
          />
        ) : (
          <>{nFormatter(player.chipsOnTable)}</>
        )}
        &nbsp;
      </div>
    </div>
  );
}
export default ChipsLabel;
